(() => {
  class EdelmanProductGallery extends HTMLElement {
    connectedCallback(){
      if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
      this.options=[...this.querySelectorAll('[data-gallery-option]')];this.index=0;
      this.addEventListener('click',event=>{
        const option=event.target.closest('[data-gallery-option]');if(option)this.show(this.options.indexOf(option));
        const step=event.target.closest('[data-gallery-step]');if(step)this.show(this.index+Number(step.dataset.galleryStep));
        if(event.target.closest('[data-gallery-zoom]'))this.querySelector('[data-gallery-dialog]').showModal();
        if(event.target.closest('[data-gallery-close]'))this.querySelector('[data-gallery-dialog]').close();
      },{signal});
      this.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}},{signal});
      this.querySelector('[data-gallery-zoom]').addEventListener('pointerdown',event=>{this.startX=event.clientX;},{signal});
      this.querySelector('[data-gallery-zoom]').addEventListener('pointerup',event=>{const delta=event.clientX-this.startX;if(Math.abs(delta)>60){this.show(this.index+(delta<0?1:-1));this.swiped=true;}},{signal});
      this.querySelector('[data-gallery-zoom]').addEventListener('click',event=>{if(this.swiped){event.stopPropagation();this.swiped=false;}},{signal});
      this.show(0);
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;}
    show(index){
      this.index=(index+this.options.length)%this.options.length;const selected=this.options[this.index];
      for(const image of this.querySelectorAll('[data-gallery-image],[data-gallery-large]')){image.src=selected.dataset.src;image.alt=selected.dataset.alt;}
      this.options.forEach(option=>option.setAttribute('aria-pressed',String(option===selected)));
      this.querySelector('[data-gallery-counter]').textContent=`${this.index+1} / ${this.options.length}`;
      this.querySelectorAll('[data-gallery-caption],[data-gallery-large-caption]').forEach(caption=>caption.hidden=selected.dataset.generated!=='true');
    }
  }
  if(!customElements.get('edelman-product-gallery'))customElements.define('edelman-product-gallery',EdelmanProductGallery);
})();
